const HERO_IMG =
  "https://images.pexels.com/photos/35177799/pexels-photo-35177799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const TRUST_POINTS = [
  "Same-Day / Next-Day Pickup",
  "Full-Service Crew Loading",
  "Locally Owned in Palm Bay, FL",
];

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end justify-start pb-20 pt-32 px-4 sm:px-6 lg:px-8 border-b border-zinc-900 overflow-hidden"
    >
      <div className="absolute inset-0 z-0 bg-neutral-950">
        <img
          src={HERO_IMG}
          alt="Heavy duty dump truck loaded out at a Brevard County job site"
          className="w-full h-full object-cover opacity-70"
        />
      </div>
      <div className="absolute inset-0 z-10 scrim-bottom" />

      <div className="relative z-20 max-w-5xl mx-auto w-full">
        <div className="max-w-3xl space-y-6">
          <span className="inline-block text-[10px] font-mono uppercase tracking-widest text-zinc-300 bg-black/80 px-3 py-1.5 rounded border border-white/10">
            Brevard County Heavy Haul Unit
          </span>
          <h1 className="text-5xl sm:text-7xl lg:text-8xl font-black tracking-tighter uppercase text-white font-display leading-[0.9]">
            Heavy Lifting Done Today.
          </h1>
          <p className="text-lg sm:text-xl text-zinc-300 leading-relaxed max-w-2xl">
            Fast same-day or next-day pickup across Brevard County. We do all the heavy lifting and loading · you don't touch a single thing.
          </p>
          <div className="pt-2 flex flex-wrap gap-3">
            <a
              href="tel:3214202707"
              data-testid="hero-call-btn"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-xl bg-white text-black font-black uppercase text-sm tracking-wider hover:bg-zinc-200 transition-colors shadow-xl"
            >
              Dispatch Brevard Crew: (321) 420-2707
            </a>
            <a
              href="#contact"
              data-testid="hero-quote-btn"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-xl bg-black/70 border border-white/30 text-white font-black uppercase text-sm tracking-wider hover:bg-zinc-900 transition-colors"
            >
              Get Free Quote
            </a>
          </div>
          <div className="pt-4 flex flex-wrap gap-6 text-xs font-mono text-zinc-300 border-t border-white/15">
            {TRUST_POINTS.map((point) => (
              <div key={point} className="flex items-center gap-2 pt-4">
                <span className="w-2 h-2 rounded-full bg-white" />
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
